import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Example three</div>
                                            <p>Five pieces of coal, a carrot and a scarf are lying on a hill
                                                near a remote house. Nobody put them
                                                on the ground but there is a reasonable explanation for why
                                                they’re there. What is it?</p>
                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport people_active">
                                                <tbody>
                                                <tr>
                                                    <th width="50%" align="left" valign="top"
                                                        className="green_curve green_curve1">Answer
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="center"
                                                        className="lightgreen">
                                                           <textarea className="curved_textarea"
                                                                     rows="5"
                                                                     cols="100"
                                                                     name="textareaExempleThree"
                                                                     value={this.props.pageData?.textareaExempleThree}
                                                                     onChange={this.props.handleChangePageData}/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div className="border_subtitle">Example four</div>
                                            <p>A man was driving alone when he spun off the road at high
                                                speed. His car crashed through a
                                                fence and bounced down a steep ravine, before plunging into
                                                a fast flowing river. As it slowly
                                                settled in the river, the man realised his arm was broken
                                                and he couldn’t release his seat belt to
                                                escape. He was trapped and the car sank. Rescuers arrived
                                                two hours later to find him still in the
                                                river and alive. How?</p>
                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport people_active">
                                                <tbody>
                                                <tr>
                                                    <th width="50%" align="left" valign="top"
                                                        className="green_curve green_curve1">Answer
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="center"
                                                        className="lightgreen">
                                                           <textarea className="curved_textarea"
                                                                     rows="5"
                                                                     cols="100"
                                                                     name="textareaExempleFour"
                                                                     value={this.props.pageData?.textareaExempleFour}
                                                                     onChange={this.props.handleChangePageData}/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <p>Now check your answers against the examples answer sheet
                                                towards the end of this tool.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpadnew lightbgcenter">
                                                <div className=" paraspace"><p><span
                                                    className="subtiltereg">Next, think about how you came up with a solution (whether it was right or wrong):</span>
                                                </p></div>
                                                <ul className="greenbullet-list uiheading">
                                                    <li><p>What was going on in your thinking?</p></li>
                                                    <li><p>How did you get to the solution?</p></li>
                                                    <li><p>What errors did you make; for example, could you
                                                        think of only one, familiar use for
                                                        something?</p></li>
                                                    <li><p>Did you make assumptions?</p></li>
                                                    <li><p>Were you being too literal?</p></li>
                                                    <li className="cntareap"><p>Were you attending to the
                                                        right information?</p></li>
                                                </ul>
                                            </div>
                                            <br/>
                                            <div className="border_subtitle">Some things to think
                                                about…
                                            </div>
                                            <div
                                                className="lightgreencontentbg keyquestionpadnew lightbgcenter">
                                                <div className="paraspace"><p><span
                                                    className="green brownbold">Example one</span></p>
                                                </div>
                                                <p>The first example challenges our preconceptions. We
                                                    may assume that everyone in the
                                                    room is male because we have a preconception that
                                                    carpenters, lorry drivers and mechanics
                                                    are typically men. We may also have a preconception
                                                    that poker is typically played by men
                                                    and not women.</p>
                                                <div className="uiheading"><p><span
                                                    className="green brownbold">Tip:</span> When
                                                    thinking laterally, try to challenge your own
                                                    preconceptions. Keeping an open
                                                    mind helps you recognise different solutions.</p>
                                                </div>
                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page4')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}